// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LCVS","textarea":"styles_textarea__3P5ro"};